import { useQuery } from '@tanstack/react-query';
import { type Format } from '@ugin/shared';

import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';

export function useMeta(format: Format) {
  return useQuery({
    queryKey: queryKeys.meta.forFormat(format),
    queryFn: () => api.meta.forFormat(format),
    staleTime: 5 * 60_000,
  });
}

export function useMatchups(params: { format?: Format; deckId?: string }) {
  return useQuery({
    queryKey: queryKeys.matchups.list(params),
    queryFn: () => api.matchups.list(params),
  });
}

export function useRecentLogs(limit = 50) {
  return useQuery({
    queryKey: queryKeys.logs.recent(limit),
    queryFn: () => api.logs.recent(limit),
    refetchInterval: 10_000,
  });
}
